<template>
  <v-container fluid>
    <!-- Verificación de permisos para ADMIN -->
    <div v-if="!canManageUsers">
      <v-alert type="error" prominent border="left">
        <v-row no-gutters>
          <v-col class="grow">
            <div class="title">🚫 Acceso Restringido</div>
            <div>
              Solo los <strong>Administradores</strong> pueden gestionar el personal de la
              tienda.
              <br />
              <small>Contacte al gerente para obtener permisos adicionales.</small>
            </div>
          </v-col>
          <v-col class="shrink">
            <v-icon color="error" size="48">mdi-shield-alert</v-icon>
          </v-col>
        </v-row>
      </v-alert>
    </div>

    <!-- Contenido principal para ADMIN -->
    <div v-else>
      <!-- KPI Dashboard Retail -->
      <v-row class="mb-4">
        <v-col cols="12" sm="6" md="3">
          <v-card
            class="mx-1 kpi-card"
            elevation="2"
            :style="{ borderTop: '4px solid #1976D2' }"
          >
            <v-card-text class="text-center py-4">
              <div class="text-overline mb-1">Personal Total</div>
              <div class="text-h5 font-weight-bold mb-2">{{ items.length }}</div>
              <div class="text-body-2">
                <v-icon class="mr-2" color="primary" size="20">mdi-account-group</v-icon>
                <span>{{ getCurrentStoreName() }}</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="mx-1 kpi-card"
            elevation="2"
            :style="{ borderTop: '4px solid #4CAF50' }"
          >
            <v-card-text class="text-center py-4">
              <div class="text-overline mb-1">Personal Activo</div>
              <div class="text-h5 font-weight-bold mb-2">{{ activeUsers }}</div>
              <div class="text-body-2">
                <span class="success--text font-weight-medium">
                  <v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>
                  {{ activePercentage }}% disponible
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="mx-1 kpi-card"
            elevation="2"
            :style="{ borderTop: '4px solid #FF9800' }"
          >
            <v-card-text class="text-center py-4">
              <div class="text-overline mb-1">Vendedores</div>
              <div class="text-h5 font-weight-bold mb-2">{{ salesStaffCount }}</div>
              <div class="text-body-2">
                <v-icon class="mr-2" color="orange" size="20">mdi-account-tie</v-icon>
                <span>En punto de venta</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="mx-1 kpi-card"
            elevation="2"
            :style="{ borderTop: '4px solid #9C27B0' }"
          >
            <v-card-text class="text-center py-4">
              <div class="text-overline mb-1">Últimos Accesos</div>
              <div class="text-h5 font-weight-bold mb-2">{{ recentAccessCount }}</div>
              <div class="text-body-2">
                <v-icon class="mr-2" color="purple" size="20">mdi-clock-outline</v-icon>
                <span>Últimas 24h</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Distribución por Roles -->
      <!-- <v-row class="mb-4">
        <v-col cols="12" md="6">
          <v-card elevation="2" height="100%">
            <v-card-title class="primary white--text py-3">
              <v-icon color="white" class="mr-2">mdi-account-details</v-icon>
              Distribución por Roles
            </v-card-title>
            <v-card-text>
              <div v-for="role in roleDistribution" :key="role.value" class="mb-3">
                <div class="d-flex justify-space-between align-center">
                  <div class="d-flex align-center">
                    <v-icon :color="role.color" class="mr-2">{{ role.icon }}</v-icon>
                    <div>
                      <div class="font-weight-medium">{{ role.text }}</div>
                      <div class="caption grey--text">{{ role.description }}</div>
                    </div>
                  </div>
                  <div class="text-right">
                    <div class="font-weight-bold">{{ role.count }}</div>
                    <div class="caption">personas</div>
                  </div>
                </div>
                <v-progress-linear
                  :value="role.percentage"
                  :color="role.color"
                  height="8"
                  rounded
                  class="mt-1"
                ></v-progress-linear>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card elevation="2">
            <v-card-title class="primary white--text py-3">
              <v-icon color="white" class="mr-2">mdi-chart-line</v-icon>
              Estado de Tokens
            </v-card-title>
            <v-card-text>
              <div class="mb-3">
                <div class="subtitle-2 grey--text">Tokens Activos</div>
                <div class="text-h6 font-weight-bold success--text">
                  {{ activeTokensCount }}
                </div>
              </div>
              <div class="mb-3">
                <div class="subtitle-2 grey--text">Tokens Inactivos</div>
                <div class="text-h6 font-weight-bold error--text">
                  {{ inactiveTokensCount }}
                </div>
              </div>
              <div>
                <div class="subtitle-2 grey--text">Último Acceso</div>
                <div class="text-h6 font-weight-bold">{{ lastAccessFormatted }}</div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->

      <!-- Toolbar con controles -->
      <v-card class="mb-4 elevation-2">
        <v-toolbar flat color="white" class="px-2">
          <v-toolbar-title class="text-h6 primary--text">
            <v-icon color="primary" class="mr-2">mdi-account-cog</v-icon>
            Personal de {{ getCurrentStoreName() }}
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Filtro por rol -->
          <v-select
            v-model="selectedRoleFilter"
            :items="roleFilterOptions"
            label="Filtrar por rol"
            dense
            outlined
            hide-details
            clearable
            class="mx-2 shrink"
            style="max-width: 200px"
          >
            <template v-slot:prepend-inner>
              <v-icon size="18">mdi-filter</v-icon>
            </template>
          </v-select>

          <!-- Búsqueda -->
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar personal"
            hide-details
            dense
            outlined
            class="mx-2 shrink"
            style="max-width: 300px"
          ></v-text-field>

          <!-- Botón nuevo empleado -->
          <v-btn color="primary" class="ml-2" @click="newForm" depressed>
            <v-icon left>mdi-account-plus</v-icon>
            Nuevo Empleado
          </v-btn>
        </v-toolbar>
      </v-card>

      <!-- Tabla de Personal -->
      <v-card class="elevation-2">
        <v-data-table
          :headers="headers"
          :items="filteredUsers"
          :items-per-page="10"
          :search="search"
          :loading="loading_status"
          class="table-cursor"
          sort-by="user_name"
          item-key="user_email"
          @click:row="handleClick"
        >
          <template v-slot:item.avatar="{ item }">
            <v-avatar
              size="40"
              :color="getRoleColor(item.user_access)"
              class="white--text"
            >
              <img
                v-if="item.user_photo"
                :src="getPhotoUrl(item.user_photo)"
                alt="avatar"
                @error="item.user_photo = null"
              />
              <v-icon v-else color="white">{{ getRoleIcon(item.user_access) }}</v-icon>
            </v-avatar>
          </template>

          <template v-slot:item.user_info="{ item }">
            <div>
              <div class="font-weight-medium">{{ item.user_name }}</div>
              <div class="caption grey--text">
                <v-icon small class="mr-1">mdi-email-outline</v-icon>
                {{ item.user_email }}
              </div>
              <div v-if="item.user_code" class="caption grey--text">
                <v-icon small class="mr-1">mdi-identifier</v-icon>
                Código: {{ item.user_code }}
              </div>
            </div>
          </template>

          <template v-slot:item.role="{ item }">
            <v-chip
              :color="getRoleColor(item.user_access)"
              text-color="white"
              class="font-weight-bold"
            >
              <v-icon left small>{{ getRoleIcon(item.user_access) }}</v-icon>
              {{ getRoleText(item.user_access) }}
            </v-chip>
          </template>

          <template v-slot:item.status="{ item }">
            <div>
              <v-chip
                :color="isUserActive(item) ? 'success' : 'error'"
                text-color="white"
                class="mb-1"
              >
                <v-icon left small>
                  {{ isUserActive(item) ? "mdi-check" : "mdi-clock-alert" }}
                </v-icon>
                {{ isUserActive(item) ? "Activo" : "Inactivo" }}
              </v-chip>
            </div>
          </template>
          <template v-slot:item.token="{ item }">
            <v-chip
              :color="item.token_active === '1' ? 'success' : 'error'"
              text-color="white"
            >
              {{ item.token_active === "1" ? "Activo" : "Inactivo" }}
            </v-chip>
          </template>

          <template v-slot:item.last_access="{ item }">
            <div class="text-caption">
              <v-icon small class="mr-1">mdi-calendar-clock</v-icon>
              {{ formatDate(item.issue_date) }}
            </div>
          </template>

          <template v-slot:no-data>
            <div class="text-center pa-4">
              <v-icon size="48" color="grey lighten-1" class="mb-2"
                >mdi-account-off</v-icon
              >
              <div class="subtitle-1 grey--text">No hay personal registrado</div>
              <v-btn color="primary" class="mt-2" @click="newForm">
                <v-icon left>mdi-account-plus</v-icon>
                Agregar Primer Empleado
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <!-- Formulario de Usuario -->
      <UserForm
        :table="table"
        :item="item"
        :dialog="dialog"
        :newItem="newItem"
        @close="dialog = false"
        @refresh="refresh()"
      />

      <!-- Diálogo de confirmación -->
      <v-dialog v-model="confirmDialog" max-width="400">
        <v-card>
          <v-card-title class="headline">
            <v-icon left :color="confirmAction.color">{{ confirmAction.icon }}</v-icon>
            {{ confirmAction.title }}
          </v-card-title>
          <v-card-text>
            {{ confirmAction.message }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="confirmDialog = false">Cancelar</v-btn>
            <v-btn
              :color="confirmAction.color"
              @click="executeConfirmAction"
              :loading="loading_status"
            >
              {{ confirmAction.confirmText }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { webserver } from "@/services/webserver.js";
import createItem from "@/utils/createUser.js";
import UserForm from "@/components/UserForm.vue";

export default {
  components: { UserForm },

  mounted() {
    this.checkPermissions();
    if (this.canManageUsers) {
      this.get_items();
    }
  },

  data() {
    return {
      table: "users",
      dialog: false,
      confirmDialog: false,
      newItem: false,
      search: "",
      loading_status: false,
      selectedRoleFilter: null,
      canManageUsers: false,
      currentUserAccess: null,
      currentUserStore: null,
      items: [],
      item: createItem(),

      confirmAction: {
        title: "",
        message: "",
        icon: "",
        color: "",
        confirmText: "",
        action: null,
        data: null,
      },

      retailRoles: {
        ADMIN: {
          text: "Administrador",
          description: "Gestión completa de la tienda",
          icon: "mdi-shield-crown",
          color: "red darken-1",
        },
        POS: {
          text: "Cajero/a",
          description: "Operación de punto de venta",
          icon: "mdi-cash-register",
          color: "blue",
        },
        VENDEDOR: {
          text: "Vendedor/a",
          description: "Atención al cliente y ventas",
          icon: "mdi-account-tie",
          color: "green",
        },
        AUDITOR: {
          text: "Auditor",
          description: "Supervisión y control",
          icon: "mdi-clipboard-check",
          color: "orange",
        },
        COMPRAS: {
          text: "Comprador/a",
          description: "Gestión de inventario y proveedores",
          icon: "mdi-cart-outline",
          color: "purple",
        },
        SUPERVISOR: {
          text: "Supervisor/a",
          description: "Supervisión de turnos",
          icon: "mdi-account-supervisor",
          color: "indigo",
        },
        StoreAdmin: {
          text: "Admin Tienda",
          description: "Configuración y gestión de personal",
          icon: "mdi-store-cog",
          color: "deep-orange",
        },
        Analista: {
          text: "Analista",
          description: "Análisis de datos e inventario (solo lectura)",
          icon: "mdi-chart-bell-curve-cumulative",
          color: "teal",
        },
      },

      headers: [
        { text: "", value: "avatar", sortable: false, width: "60" },
        { text: "Empleado", value: "user_info", sortable: true },
        { text: "Rol", value: "role", sortable: true, width: "150" },
        { text: "Estado", value: "status", sortable: true, width: "140" },
        { text: "Token", value: "token", sortable: true, width: "140" },
        { text: "Último Acceso", value: "last_access", sortable: true, width: "150" },
      ],

      activeThreshold: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    };
  },

  computed: {
    // ... todos los computed anteriores igual ...
    filteredUsers() {
      let users = this.items;
      if (this.selectedRoleFilter) {
        users = users.filter((user) => user.user_access === this.selectedRoleFilter);
      }
      return users;
    },

    activeUsers() {
      return this.items.filter((user) => this.isUserActive(user)).length;
    },

    activePercentage() {
      if (this.items.length === 0) return 0;
      return Math.round((this.activeUsers / this.items.length) * 100);
    },

    salesStaffCount() {
      return this.items.filter((user) => ["POS", "VENDEDOR"].includes(user.user_access))
        .length;
    },

    recentAccessCount() {
      const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
      return this.items.filter((user) => {
        if (!user.issue_date) return false;
        return new Date(user.issue_date) > yesterday;
      }).length;
    },

    activeTokensCount() {
      return this.items.filter((user) => user.token_active === "1").length;
    },

    inactiveTokensCount() {
      return this.items.filter((user) => user.token_active !== "1").length;
    },

    lastAccessFormatted() {
      if (!this.items.length) return "N/A";
      const lastAccess = this.items
        .filter((user) => user.issue_date)
        .map((user) => new Date(user.issue_date))
        .sort((a, b) => b - a)[0];
      return lastAccess ? this.formatDate(lastAccess) : "N/A";
    },

    roleDistribution() {
      const distribution = {};
      const total = this.items.length;

      Object.keys(this.retailRoles).forEach((roleKey) => {
        distribution[roleKey] = 0;
      });

      this.items.forEach((user) => {
        if (distribution[user.user_access] !== undefined) {
          distribution[user.user_access]++;
        }
      });

      return Object.entries(distribution)
        .filter(([, count]) => count > 0)
        .map(([roleKey, count]) => ({
          value: roleKey,
          count,
          percentage: total > 0 ? (count / total) * 100 : 0,
          ...this.retailRoles[roleKey],
        }))
        .sort((a, b) => b.count - a.count);
    },

    roleFilterOptions() {
      return [
        { text: "Todos los roles", value: null },
        ...Object.entries(this.retailRoles).map(([value, config]) => ({
          text: config.text,
          value,
        })),
      ];
    },
  },

  methods: {
    checkPermissions() {
      const currentUser = this.$store?.state?.profile || window.profile;

      if (!currentUser) {
        this.canManageUsers = false;
        return;
      }

      this.currentUserAccess = currentUser.user_access;
      this.currentUserStore = currentUser.store_id || window.profile?.store_id;
      this.canManageUsers = this.currentUserAccess === "ADMIN" || this.currentUserAccess === "StoreAdmin";
    },

    getCurrentStoreName() {
      const currentUser = this.$store?.state?.profile || window.profile;
      return currentUser?.store_name || window.profile?.store_name || "Mi Tienda";
    },

    getStoreId() {
      return (
        window.profile?.store_id ||
        this.currentUserStore ||
        this.$store?.state?.profile?.store_id
      );
    },

    // ✅ USANDO ENDPOINT ESPECÍFICO: get_users
    get_items() {
      if (!this.canManageUsers) {
        console.error("Acceso denegado a gestión de usuarios");
        return;
      }

      this.loading_status = true;
      const storeId = this.getStoreId();

      const qry = {
        store: storeId,
      };

      console.log("📤 Llamando endpoint get_users:", qry);

      webserver("get_users", qry, (data) => {
        this.loading_status = false;
        console.log("📥 Respuesta get_users:", data);

        if (Array.isArray(data) && data.length > 0) {
          this.items = data.filter((user) =>
            Object.keys(this.retailRoles).includes(user.user_access)
          );
        } else if (data && data.error) {
          console.error("Error al obtener usuarios:", data.message);
          this.items = [];
        } else {
          this.items = [];
        }
      });
    },

    isUserActive(user) {
      if (!user.issue_date) return false;
      const accessDate = new Date(user.issue_date);
      return accessDate > this.activeThreshold;
    },

    getPhotoUrl(photoData) {
      if (!photoData) return null;
      if (photoData.startsWith("data:image/")) {
        return photoData;
      } else if (photoData.length > 100) {
        return `data:image/jpeg;base64,${photoData}`;
      } else {
        return photoData;
      }
    },

    getRoleColor(roleKey) {
      return this.retailRoles[roleKey]?.color || "grey";
    },

    getRoleIcon(roleKey) {
      return this.retailRoles[roleKey]?.icon || "mdi-account";
    },

    getRoleText(roleKey) {
      return this.retailRoles[roleKey]?.text || roleKey;
    },

    formatDate(dateString) {
      if (!dateString) return "Nunca";
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      } catch (e) {
        return "N/A";
      }
    },

    handleClick(user) {
      this.editUser(user);
    },

    editUser(user) {
      this.item = JSON.parse(JSON.stringify(user));
      this.newItem = false;
      this.dialog = true;
    },

    toggleToken(user) {
      const newStatus = user.token_active === "1" ? "0" : "1";
      const action = newStatus === "1" ? "activar" : "suspender";

      this.confirmAction = {
        title: newStatus === "1" ? "Activar Acceso" : "Suspender Acceso",
        message: `¿Está seguro de ${action} el acceso de ${user.user_name}?`,
        icon: newStatus === "1" ? "mdi-play" : "mdi-pause",
        color: newStatus === "1" ? "success" : "warning",
        confirmText: newStatus === "1" ? "Activar" : "Suspender",
        action: "toggleToken",
        data: { user, newStatus },
      };

      this.confirmDialog = true;
    },

    deleteUser(user) {
      if (user.user_access === "ADMIN") {
        this.showError("No se puede eliminar a un administrador");
        return;
      }

      this.confirmAction = {
        title: "Eliminar Empleado",
        message: `¿Está seguro de eliminar a ${user.user_name}? Esta acción no se puede deshacer.`,
        icon: "mdi-delete",
        color: "error",
        confirmText: "Eliminar",
        action: "deleteUser",
        data: user,
      };

      this.confirmDialog = true;
    },

    executeConfirmAction() {
      if (this.confirmAction.action === "toggleToken") {
        this.executeToggleToken();
      } else if (this.confirmAction.action === "deleteUser") {
        this.executeDeleteUser();
      }
    },

    // ✅ USANDO ENDPOINT ESPECÍFICO: toggle_user_access
    executeToggleToken() {
      const { user, newStatus } = this.confirmAction.data;
      this.loading_status = true;
      const storeId = this.getStoreId();

      const qry = {
        store: storeId,
        user_email: user.user_email,
        token_active: newStatus,
      };

      console.log("📤 Llamando endpoint toggle_user_access:", qry);

      webserver("toggle_user_access", qry, (response) => {
        this.loading_status = false;
        this.confirmDialog = false;
        console.log("📥 Respuesta toggle_user_access:", response);

        if (response && response.error) {
          this.showError("Error al actualizar: " + response.message);
        } else {
          this.showSuccess(
            `Acceso ${newStatus === "1" ? "activado" : "suspendido"} correctamente`
          );
          this.refresh();
        }
      });
    },

    // ✅ USANDO ENDPOINT ESPECÍFICO: delete_user
    executeDeleteUser() {
      const user = this.confirmAction.data;
      this.loading_status = true;
      const storeId = this.getStoreId();

      const qry = {
        store: storeId,
        user_email: user.user_email,
      };

      console.log("📤 Llamando endpoint delete_user:", qry);

      webserver("delete_user", qry, (response) => {
        this.loading_status = false;
        this.confirmDialog = false;
        console.log("📥 Respuesta delete_user:", response);

        if (response && response.error) {
          this.showError("Error al eliminar: " + response.message);
        } else {
          this.showSuccess("Empleado eliminado correctamente");
          this.refresh();
        }
      });
    },

    newForm() {
      this.item = createItem();
      this.item.store_id = this.getStoreId();
      this.item.token_active = "1";
      this.newItem = true;
      this.dialog = true;
    },

    refresh() {
      this.dialog = false;
      this.get_items();
    },

    showError(message) {
      if (this.$store.dispatch) {
        this.$store.dispatch("showMessage", {
          color: "error",
          message: message,
        });
      }
    },

    showSuccess(message) {
      if (this.$store.dispatch) {
        this.$store.dispatch("showMessage", {
          color: "success",
          message: message,
        });
      }
    },
  },
};
</script>

<style scoped>
.kpi-card {
  transition: all 0.3s;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12) !important;
}

.table-cursor >>> tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}

.table-cursor >>> tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.v-data-table >>> .v-data-table__wrapper {
  border-radius: 8px;
}
</style>
